import React from "react";
import { isMobileOnly } from "react-device-detect";
import ImgCaption from "./ImgCaption";

interface ImgFullWidthProps {
  caption?: string;
  cssClass?: string;
  elementId?: string;
  url?: string;
}

const ImgFullWidth: React.FC<ImgFullWidthProps> = ({
  caption,
  cssClass = "",
  elementId = "",
  url,
}) => (
  <div
    id={elementId}
    className={`rn-page-title-area pt--250 pb--190 bg_image mb--40 ${cssClass}`}
    data-black-overlay="2"
    style={
      url
        ? {
            backgroundImage: `url(${url})`,
            backgroundAttachment: `${isMobileOnly ? "scroll" : "fixed"}`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }
        : {}
    }
  >
    <ImgCaption caption={caption} />
  </div>
);

export default ImgFullWidth;
